<template>
  <section class="cambo">
    <div class="title" @click="selectClick">
      <h2>套餐项目</h2>
      <span v-if="selectable" class="select">{{
        selectedCombos.length > 0 ? '重选' : '选择'
      }}</span>
    </div>
    <ul v-if="selectedCombos.length > 0" class="selected-cambo-list">
      <li
        v-for="(item, index) in selectedCombos"
        class="selected-combo-item"
        :key="index"
      >
        {{ item }}
      </li>
    </ul>

    <van-popup v-model="popupShow" position="bottom" class="combo-select-popup">
      <div class="popup-title">
        <h2>
          请选择套餐项目<span class="tip"
            >(必选<em>{{ requiredCombosNum }}</em
            >个)</span
          >
        </h2>
        <i class="close" @click="popupShow = false"></i>
      </div>
      <ul class="popup-option-list">
        <li
          v-for="(item, index) in popupOptions"
          :key="index"
          class="popup-option-item"
          :class="{ selected: item.selected }"
          @click="item.selected = !item.selected"
        >
          {{ item.value }}
        </li>
      </ul>
      <button
        class="popup-confirm-button"
        :disabled="
          popupOptions.filter(item => item.selected).length != requiredCombosNum
        "
        @click="confirmClick"
      >
        确定
      </button>
      <div class="menu_wkBox_back_box"></div>
    </van-popup>
  </section>
</template>
<script>
import { Popup } from 'vant'

export default {
  components: {
    [Popup.name]: Popup
  },
  props: {
    /* 可选套餐 */
    optionalCombos: {
      type: Array,
      default() {
        return []
      }
    },
    /* 已选套餐 */
    selectedCombos: {
      type: Array,
      require: true
    },
    /* 必选数量 */
    requiredCombosNum: {
      type: Number,
      default: 1
    },
    /* 是否可选 */
    selectable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      popupShow: false,
      popupOptions: []
    }
  },
  methods: {
    selectClick() {
      if (!this.selectable) {
        return
      }
      this.popupOptions = this.optionalCombos.map(item => ({
        value: item,
        selected: this.selectedCombos.indexOf(item) > -1
      }))
      this.popupShow = true
    },
    confirmClick() {
      this.$emit(
        'update:selectedCombos',
        this.popupOptions.filter(item => item.selected).map(item => item.value)
      )
      this.popupShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.cambo {
  border-radius: rem(16px);
  background: #ffffff;
  overflow: hidden;
  .title {
    display: flex;
    align-items: center;
    padding: rem(34px) rem(24px) rem(30px);
    &:not(:last-child) {
      padding-bottom: rem(28px);
    }
    h2 {
      flex: 1;
      line-height: rem(36px);
      color: #121212;
      font-weight: 500;
      font-size: rem(30px);
      @include ellicpsis;
    }
    .select {
      line-height: rem(32px);
      color: #808080;
      font-size: rem(26px);
      padding-right: rem(28px);
      background: url(~@/assets/images/icon-right_gray.png) right
        center/rem(20px) rem(20px) no-repeat;
    }
  }
  .selected-cambo-list {
    padding: 0 rem(24px);
    margin-bottom: rem(40px);
    .selected-combo-item {
      position: relative;
      padding-left: rem(20px);
      margin-bottom: rem(20px);
      line-height: rem(32px);
      color: #666666;
      font-size: rem(26px);
      @include ellicpsis;
      &:last-child {
        margin-bottom: 0;
      }
      &::before {
        position: absolute;
        content: '';
        display: block;
        width: rem(8px);
        height: rem(8px);
        background: #999999;
        border-radius: 50%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .combo-select-popup {
    display: flex;
    flex-direction: column;
    border-radius: rem(16px) rem(16px) 0 0;
    background: #ffffff;
    .popup-title {
      flex: none;
      display: flex;
      align-items: center;
      padding: rem(32px) rem(32px) rem(32px) rem(24px);
      h2 {
        flex: 1;
        line-height: rem(44px);
        color: #121212;
        font-weight: 500;
        font-size: rem(36px);
        .tip {
          color: #666666;
          font-size: rem(28px);
          margin-left: rem(6px);
          em {
            color: #ff5900;
            font-weight: 500;
          }
        }
      }
      .close {
        flex: none;
        width: rem(25px);
        height: rem(25px);
        background: url(~@/assets/images/icon-close.png) 0 0/100% 100% no-repeat;
      }
    }
    .popup-option-list {
      flex: none;
      padding: 0 rem(24px);
      margin-bottom: rem(16px);
      max-height: rem(624px);
      overflow: auto;
      .popup-option-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: rem(72px);
        border-radius: rem(36px);
        background: #f5f5f5;
        line-height: 30px;
        color: #262626;
        font-size: rem(28px);
        margin-bottom: rem(32px);
        @include ellicpsis;
        &.selected {
          border: 1px solid #ff9962;
          background: #fff4ed;
          color: #ff5900;
        }
      }
    }
    .popup-confirm-button {
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      height: rem(80px);
      border-radius: rem(40px);
      background: linear-gradient(270deg, #ff5900 0%, #ff8800 100%);
      line-height: rem(40px);
      color: #ffffff;
      font-size: rem(32px);
      opacity: 1;
      margin: rem(10px) rem(24px);
      &[disabled] {
        opacity: 0.36;
      }
    }
  }
}
</style>
